import axios from "axios";
import API from "../helpers/api";
import { toast } from "react-toastify";

const searchInput = {
  ShipId: 0,
  Title: "",
  NoteId: 0,
  Remark: "",
  Date: "",
  sortby: "desc",
  sortorder: "date",
  PageNumber: 1,
  PageSize: 10,
};
export const getNotesList = (searchData) => {
  let url = `${API.GetShipNote}?ShipId=${searchData.ShipId}&Title=${searchData.Title}&NoteId=${searchData.NoteId}&Remark=${searchData.Remark}&Date=${searchData.Date}&sortby=${searchData.sortby}&sortorder=${searchData.sortorder}&PageNumber=${searchData.PageNumber}&PageSize=${searchData.PageSize}`;
  return (dispatch) => {
   axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getShipNotesList",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getShipNotesListFailure",
          error: "ERROR",
        });
    });
  };
};

export const getNoteById = (noteID) => {
  let url = `${API.GetShipNote}?NoteId=${noteID}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "NoteDetails",
          data: response.data != null && response.data.length > 0 ? response.data[0] : null,
        });
      })
      .catch((error) => {
        dispatch({
          type: "NoteDetailFailure",
          error: "ERROR",
        });
    });
  };
};

export const AddNotesData = (input, hist, t) => {
  
  let url = `${API.AddNote}`;
  searchInput.ShipId = input.shipId;
  return (dispatch) => {
      axios
        .post(url, input)
        .then((response) => {
          dispatch({
            type: "AddNoteSuccess",
            data: response.data,
          });
          dispatch(getNotesList(searchInput));
          hist.goBack();
          toast.success(t('CommonText.CommonAdd'), {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
        .catch((error) => {
          dispatch({
            type: "AddNoteFailure",
            error: "ERROR",
          });
        });
  };
};

export const UpdateNotesData = (input, hist,t) => {
  
  let url = `${API.UpdateNote}`;
  searchInput.ShipId = input.shipId;
  return (dispatch) => {
      axios
        .post(url, input)
        .then((response) => {
          dispatch({
            type: "UpdateNoteSuccess",
            data: response.data,
          });
          dispatch(getNotesList(searchInput));
          hist.goBack();
          toast.success(t('CommonText.CommonUpdate'), {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
        .catch((error) => {
          dispatch({
            type: "UpdateNoteFailure",
            error: "ERROR",
          });
        });
  };
};

export const deleteNote = (Id, shipId,createdBy) => {
  let url = `${API.DeleteNote}?noteID=${Id}&modifiedBy=${createdBy}`;
  searchInput.ShipId = shipId;
  return (dispatch) => {
      axios
        .delete(url)
        .then((response) => {
          dispatch({
            type: "deleteNoteSuccess",
            data: response.data,
          });
          dispatch(getNotesList(searchInput));
          toast.success("Deleted Successfully", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
          });
        })
        .catch((error) => {
          dispatch({
            type: "deleteNoteFailure",
            error: "ERROR",
          });
        });
  };
};

